<a
  href="#shell-main"
  class="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[70] rounded-sm2 border border-primarydim bg-primary px-3 py-2 font-label text-ui-label font-bold uppercase tracking-ui-label text-onprimary shadow-insetline"
>
  Skip to content
</a>

<main id="shell-main" class="h-dvh min-h-screen bg-bg text-ink">
  <div class="relative flex h-dvh min-h-screen flex-col overflow-hidden bg-bg">
    <app-account-access-notice class="shrink-0" />
    <header class="z-40 shrink-0">
      <div class="flex h-11 items-center justify-between bg-panelLow px-4">
        <div class="flex min-w-0 items-center gap-6">
          <a
            routerLink="/dashboard"
            class="flex h-11 items-center"
            aria-label="Fluxtail dashboard"
            (click)="closeMenus()"
          >
            <img src="/logo-full-dark.svg?v=20260606" alt="Fluxtail" class="h-6 w-auto" />
          </a>

          <div class="h-4 w-px bg-line"></div>

          <nav
            class="flex min-w-0 items-center gap-6 overflow-x-auto font-label text-ui-label font-bold uppercase tracking-ui-label text-muted"
            aria-label="Primary"
          >
            @for (link of primaryLinks; track link.route) {
              <a
                [routerLink]="link.route"
                class="inline-flex h-11 items-center gap-2 whitespace-nowrap border-b-2 px-px pt-px text-ui-label font-bold uppercase tracking-ui-label transition-colors duration-150 hover:text-white"
                [class.border-transparent]="!isActiveRoute(link.route, link.exact ?? false)"
                [class.text-muted]="!isActiveRoute(link.route, link.exact ?? false)"
                [class.border-white]="isActiveRoute(link.route, link.exact ?? false)"
                [class.text-white]="isActiveRoute(link.route, link.exact ?? false)"
                (click)="closeMenus()"
              >
                <span class="grid size-3.5 shrink-0 place-items-center">
                  <span class="iconify text-sm {{ link.icon }}"></span>
                </span>
                <span>{{ link.label }}</span>
              </a>
            }
          </nav>
        </div>

        <div class="ml-4 flex shrink-0 items-center gap-2">
          <div class="relative flex min-w-0 items-center">
            <span class="iconify tabler--building-community pointer-events-none absolute left-2 text-sm text-muted" aria-hidden="true"></span>
            <select
              aria-label="Switch account"
              class="h-8 w-52 max-w-[35vw] appearance-none truncate rounded-sm2 border border-transparent bg-panelLow pl-7 pr-7 text-ui-meta font-medium text-white transition hover:border-line hover:bg-panel2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-line2 disabled:cursor-default"
              [ngModel]="activeAccountId() ?? ''"
              [title]="activeAccountName()"
              [disabled]="availableMemberships().length < 2"
              (ngModelChange)="switchAccount($event)"
            >
              @for (membership of availableMemberships(); track membership.account_id) {
                <option [value]="membership.account_id">
                  {{ membership.account?.name }}{{ membership.account?.lifecycle_state === 'closing' ? ' (closing)' : '' }}
                </option>
              } @empty {
                <option value="">{{ activeAccountName() }}</option>
              }
            </select>
            @if (availableMemberships().length > 1) {
              <span class="iconify tabler--chevron-down pointer-events-none absolute right-2 text-sm text-muted" aria-hidden="true"></span>
            }
          </div>

          <div class="relative">
            <button
              type="button"
              class="grid h-7 w-7 place-items-center rounded-sm2 bg-transparent text-muted transition hover:bg-panel2 hover:text-white hover:shadow-insetline"
              (click)="toggleProfileDrawer()"
              aria-label="Open account menu"
              title="Open account menu"
            >
              <span class="iconify tabler--user-circle text-base"></span>
            </button>

            @if (profileDrawerOpen()) {
              <button
                type="button"
                class="fixed inset-0 z-20 bg-transparent"
                (click)="closeMenus()"
                aria-label="Close account menu"
              ></button>

              <section
                class="absolute right-0 top-[calc(100%+0.625rem)] z-30 w-[19rem] overflow-hidden rounded-sm2 border border-line/65 bg-panel/95 p-2 shadow-ghost backdrop-blur"
                aria-label="Account menu"
              >
                <div class="flex items-start justify-between gap-3 px-2 py-2">
                  <div class="min-w-0">
                    <div
                      class="font-label text-ui-label font-bold uppercase tracking-ui-label text-muted"
                    >
                      Profile
                    </div>
                    <div class="mt-1 truncate text-sm font-medium text-white">
                      {{ user()?.name || 'Fluxtail user' }}
                    </div>
                    <div class="truncate text-ui-meta text-muted">
                      {{ user()?.email || 'No email loaded' }}
                    </div>
                  </div>
                  <button
                    type="button"
                    class="grid h-7 w-7 shrink-0 place-items-center rounded-sm2 text-muted transition hover:bg-panel2 hover:text-white hover:shadow-insetline"
                    (click)="closeMenus()"
                    aria-label="Close account menu"
                    title="Close account menu"
                  >
                    <span class="iconify tabler--x text-base"></span>
                  </button>
                </div>

                <div class="mt-1 border-t border-line/30 pt-2">
                  <div class="space-y-1">
                    @for (link of profileLinks; track link.route) {
                      <a
                        [routerLink]="link.route"
                        class="flex w-full items-center gap-3 rounded-sm2 px-3 py-2 text-left text-muted transition hover:bg-panel2 hover:text-white"
                        [class.bg-panelLow/80]="!isActiveRoute(link.route, link.exact ?? false)"
                        [class.bg-panel2]="isActiveRoute(link.route, link.exact ?? false)"
                        [class.text-white]="isActiveRoute(link.route, link.exact ?? false)"
                        [class.shadow-insetline]="isActiveRoute(link.route, link.exact ?? false)"
                        (click)="closeMenus()"
                      >
                        <span class="grid size-4 shrink-0 place-items-center text-line2">
                          <span class="iconify text-sm {{ link.icon }}"></span>
                        </span>
                        <span class="min-w-0 flex-1">
                          <span
                            class="block font-label text-ui-label font-bold uppercase tracking-ui-label"
                            >{{ link.label }}</span
                          >
                        </span>
                      </a>
                    }
                    <a
                      href="https://docs.fluxtail.io"
                      target="_blank"
                      rel="noopener"
                      class="flex w-full items-center gap-3 rounded-sm2 bg-panelLow/80 px-3 py-2 text-left text-muted transition hover:bg-panel2 hover:text-white"
                      (click)="closeMenus()"
                    >
                      <span class="grid size-4 shrink-0 place-items-center text-line2">
                        <span class="iconify tabler--book-2 text-sm"></span>
                      </span>
                      <span class="font-label text-ui-label font-bold uppercase tracking-ui-label">
                        Documentation
                      </span>
                    </a>
                  </div>
                </div>

                <div class="mt-2 border-t border-line/30 pt-2">
                  <div
                    class="px-2 pb-2 font-label text-ui-label font-bold uppercase tracking-ui-label text-muted"
                  >
                    Theme
                  </div>
                  <div
                    class="grid grid-cols-3 gap-1 rounded-sm2 border border-line/45 bg-panelLow/80 p-1 shadow-insetline"
                  >
                    <button
                      type="button"
                      class="inline-flex items-center justify-center gap-1.5 rounded-sm2 px-2 py-2 text-ui-label font-bold uppercase tracking-ui-label text-muted transition hover:bg-panel2 hover:text-white"
                      [class.bg-panel2]="themeService.theme() === 'light'"
                      [class.text-white]="themeService.theme() === 'light'"
                      [class.shadow-insetline]="themeService.theme() === 'light'"
                      (click)="setTheme('light')"
                      title="Use light theme"
                    >
                      <span class="iconify tabler--sun text-sm"></span>
                      <span>Light</span>
                    </button>
                    <button
                      type="button"
                      class="inline-flex items-center justify-center gap-1.5 rounded-sm2 px-2 py-2 text-ui-label font-bold uppercase tracking-ui-label text-muted transition hover:bg-panel2 hover:text-white"
                      [class.bg-panel2]="themeService.theme() === 'dark'"
                      [class.text-white]="themeService.theme() === 'dark'"
                      [class.shadow-insetline]="themeService.theme() === 'dark'"
                      (click)="setTheme('dark')"
                      title="Use dark theme"
                    >
                      <span class="iconify tabler--moon text-sm"></span>
                      <span>Dark</span>
                    </button>
                    <button
                      type="button"
                      class="inline-flex items-center justify-center gap-1.5 rounded-sm2 px-2 py-2 text-ui-label font-bold uppercase tracking-ui-label text-muted transition hover:bg-panel2 hover:text-white"
                      [class.bg-panel2]="themeService.theme() === 'system'"
                      [class.text-white]="themeService.theme() === 'system'"
                      [class.shadow-insetline]="themeService.theme() === 'system'"
                      (click)="setTheme('system')"
                      title="Use system theme"
                    >
                      <span class="iconify tabler--device-desktop text-sm"></span>
                      <span>Auto</span>
                    </button>
                  </div>
                </div>

                <div class="mt-2 border-t border-line/30 pt-2">
                  <button
                    type="button"
                    class="flex w-full items-center justify-between rounded-sm2 border border-bad/35 bg-badpanel/12 px-3 py-2 text-left text-bad transition hover:bg-badpanel/18 hover:shadow-insetline"
                    title="Log out"
                    (click)="logout()"
                  >
                    <span
                      class="inline-flex items-center gap-2 font-label text-ui-label font-bold uppercase tracking-ui-label"
                    >
                      <span class="iconify tabler--logout-2 text-sm"></span>
                      <span>Logout</span>
                    </span>
                    <span class="font-mono text-ui-label text-bad/70">leave</span>
                  </button>
                </div>
                <div class="px-2 pb-1 pt-3 text-ui-label text-muted">
                  <a href="https://db-ip.com" target="_blank" rel="noopener noreferrer"
                    class="transition hover:text-white hover:underline">IP geolocation by DB-IP</a>
                  <span aria-hidden="true"> / </span>
                  <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer"
                    class="transition hover:text-white hover:underline">CC BY 4.0</a>
                </div>
              </section>
            }
          </div>
        </div>
      </div>

      @if (!isLiveTailRoute()) {
        <app-shell-subnav
          [tabs]="workspaceTabs"
          [currentPath]="currentPath() === '/settings/plans' ? '/settings/billing' : currentPath()"
          (tabClick)="closeMenus()"
        />
      }

      @if (localChrome(); as chrome) {
        <div class="shrink-0 border-t border-line/40 bg-bg px-4 py-3">
          <div class="mx-auto w-full max-w-[84rem]">
            <div class="flex items-center justify-between gap-4">
              <div class="font-mono text-ui-meta text-muted">{{ chrome.left }}</div>
              @if (chrome.right) {
                <div
                  class="font-label text-ui-label font-bold uppercase tracking-ui-label text-muted"
                >
                  {{ chrome.right }}
                </div>
              }
            </div>
          </div>
        </div>
      }
    </header>

    <app-email-verification-banner />

    <div class="relative min-h-0 flex-1 bg-bg">
      <div
        class="h-full min-h-0"
        [class.overflow-hidden]="isLiveTailRoute()"
        [class.overflow-y-auto]="!isLiveTailRoute()"
        [class.p-0]="isLiveTailRoute()"
        [class.p-8]="!isLiveTailRoute()"
      >
        <div
          class="min-h-full"
          [class.h-full]="isLiveTailRoute()"
          [class.mx-auto]="!isLiveTailRoute()"
          [class.max-w-[84rem]]="!isLiveTailRoute()"
        >
          <router-outlet />
        </div>
      </div>
    </div>
  </div>
</main>
